<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { VTextArea } from '@/modules/shared/components'
import { useCandidateStore } from '@/modules/connecting/stores/candidate-store'
import { useWorkspaceOnboardingStore } from '../../stores/workspace-onboarding-store'

const candidateStore = useCandidateStore()
const onboardingStore = useWorkspaceOnboardingStore()

const form = ref({ investment_thesis: '' as string | null })

const candidate = computed(() => {
  const id = onboardingStore.workspace?.connecting_candidate_id
  return id ? candidateStore.getCandidate(id.toString()) : undefined
})

watch(
  candidate,
  (c) => {
    if (!c) return
    form.value.investment_thesis = c.investment_thesis || ''
  },
  { immediate: true },
)

const submit = async (): Promise<boolean> => {
  const candidateId = onboardingStore.workspace?.connecting_candidate_id
  if (!candidateId) return false

  await candidateStore.updateCandidate({
    id: candidateId,
    subject_id: onboardingStore.workspace!.id,
    subject_type: 'Group',
    investment_thesis: form.value.investment_thesis,
  })
  return true
}

defineExpose({ submit })
</script>

<template>
  <div class="flex flex-1 flex-col">
    <VTextArea
      v-model="form.investment_thesis"
      label=""
      placeholder="Example: We lead $500K–$2M checks into pre-seed and seed-stage vertical SaaS companies in North America..."
    />
    <div class="mt-1 text-right text-xs text-gray-400">{{ (form.investment_thesis || '').length }} / 500</div>
  </div>
</template>
